import * as React from 'react';
import { GridComponent, ColumnsDirective, ColumnDirective, Page, Toolbar, Edit, Inject, Sort } from '@syncfusion/ej2-react-grids';
//import { data } from '../../csi_data/analitica_resumen.json';
import { /* config, */ CustomWebApiAdaptor} from '../../_helpers'
import { SampleBase } from '../../syncfusion/sample-base';
import { DataManager, Query, DataUtil, Predicate } from '@syncfusion/ej2-data';
import { authenticationService } from '../../_services'
import { setCulture,loadCldr,L10n  } from '@syncfusion/ej2-base';
import * as gregorian from 'cldr-data/main/es-CO/ca-gregorian.json';
import * as numbers from 'cldr-data/main/es-CO/numbers.json';
import * as timeZoneNames from 'cldr-data/main/es-CO/timeZoneNames.json';
import * as numberingSystems from 'cldr-data/supplemental/numberingSystems.json';
import * as weekData from 'cldr-data/supplemental/weekData.json';// To load the culture based first day of week
import * as L10n_es from '@syncfusion/ej2-locale/src/es.json'
setCulture("es-CO");
L10n.load({"es-CO":L10n_es.es});
DataUtil.serverTimezoneOffset = -5;
let CfgOptions;
let g_url;
let g_valorpk;
        
        
/* 
class ActionResult deleteLine(int key)
{
    //Delete record in database
    console.log(key)
} */

/* export class CustomRemoteSaveAdaptor extends RemoteSaveAdaptor {  
  processResponse() {
      debugger;
      //calling base class processResponse function
      const original = super.processResponse.apply(this, arguments);
      //incluir modificaciones aqui.
      return { result: original.data  , count: original.totalreg, currentPage: original.pagina };
  }
} */


export class mttoLote extends SampleBase {
    constructor() {
        super(...arguments);
        
        // Forzar windows.config
        if (!window.config) {
          //this.config = {"HostUrl":"http://25.60.233.109:",
          //                "HostUrlAuth":"http://25.60.233.109:5001/api/v1/",
          //                "HostEndUrl":"/api/v1/"};
          //debugger
          this.config = JSON.parse(sessionStorage.config);
          }
        else {
          this.config = window.config;
        }
        //this.config = window.config;
        this.toolbarOptions = ['Add', 'Edit', 'Delete', 'Update', 'Cancel'];
        this.editSettings = { allowEditing: true, allowAdding: true, allowDeleting: true, mode: 'Normal', showDeleteConfirmDialog: true };
        this.formatDate = {type:'date',  format:'yMd'};
        this.editparams = { params: { popupHeight: '300px', locale: "es-CO", format:'dd-MM-yyyy', type:'date', placeholder: "Elige una fecha" }};
        this.validationRules = { required: true };
        this.validationERules = { required: true, email: true };
        this.validationNRules = { required: true, number: true };
        this.validationDRules = { required: true, date: true }
        this.pageSettings = { pageCount: 5, pageSize: 10, pageSizes: true };
        this.sortingOptions = { columns: [ { field: 'fecha_inicio', direction: 'Descending' }] };
        
        this.predicate = new Predicate('fecha_inicio', 'greaterthan', '1990-01-01');
        /* this.predicate = new Predicate('id_lote', 'startswith', '5');
        this.predicate = this.predicate.and('id_cosecha', 'contains', '1');
        this.predicate2 = new Predicate('id_cosecha','endswith','1');
        this.predicate = this.predicate.or(this.predicate2); */

        console.log('Condicion');
        console.log(this.predicate);
        //console.log(this.predicate.toJson())
        this.query = new Query().sortByDesc('fecha_inicio').where(this.predicate);
        
        CfgOptions = authenticationService.currentUserValue.usuario.configuracion.replace(/'/g,"\"");
        CfgOptions = CfgOptions.replace(/: False/g,": false");
        CfgOptions = CfgOptions.replace(/: True/g,": true");
        CfgOptions = JSON.parse(CfgOptions).gridtable[authenticationService.currentUserValue.usuario.idioma];
        //debugger;
        if (!CfgOptions[this.props.opcion].puerto) {
          CfgOptions[this.props.opcion].puerto = '5002';
        }
        //console.log(this.config.HostUrl)
        //console.log(CfgOptions[this.props.opcion].puerto)
        //console.log(this.config.HostEndUrl)
        //console.log(CfgOptions[this.props.opcion].endpoint)
        //console.log(this.props.opcion)

        g_url = this.config.HostUrl + CfgOptions[this.props.opcion].puerto + this.config.HostEndUrl + CfgOptions[this.props.opcion].endpoint;
        //this.data = new DataManager({ url: config.HostUrl+"programa/lotes/", 
        this.data = new DataManager({ url: this.config.HostUrl + CfgOptions[this.props.opcion].puerto + this.config.HostEndUrl + CfgOptions[this.props.opcion].endpoint, 
                                      insertUrl: this.config.HostUrl + CfgOptions[this.props.opcion].puerto + this.config.HostEndUrl + CfgOptions[this.props.opcion].endpoint,
                                      removeUrl: this.config.HostUrl + CfgOptions[this.props.opcion].puerto + this.config.HostEndUrl + CfgOptions[this.props.opcion].endpoint,
                                      updateUrl: this.config.HostUrl + CfgOptions[this.props.opcion].puerto + this.config.HostEndUrl + CfgOptions[this.props.opcion].endpoint,
                                      headers:[{ "Content-Type":  "application / json",
                                                  "api-token": `${authenticationService.currentUserValue.jwt_token}`
                                                }],
                                      body: {"id_cosecha":2},
                                      adaptor: new CustomWebApiAdaptor() ,
                                      crossDomain: true});  
                                    
        //debugger;
        console.log('consulta datos');
        console.log(g_url);
        console.log(this.data);
/*         this.dataGroup = new DataManager({ url: config.HostUrl+"grupo/", 
                                          adaptor: new CustomWebApiAdaptor(),
                                          headers:[{ "Content-Type":  "application / json",
                                                      "api-token": `${authenticationService.currentUserValue.jwt_token}`
                                                    }], 
                                          crossDomain: true});  */
                                          
        
      
    }

    onClickTabla () {
      debugger;
      console.log('click tabla');
      console.log(this.gridObj);
      console.log(this.data);

    }
    onActionComplete(args) {
      //debugger
      if(args.requestType === "delete"){
          alert("Registro Borrado Exitosamente");
          var grid = document.getElementsByClassName('e-grid')[0].ej2_instances[0] ;
        //grid.dataSource.dataSource.url = config.HostUrl + CfgOptions[this.props.opcion].puerto + config.HostEndUrl + CfgOptions[this.props.opcion].endpoint
        grid.dataSource.dataSource.url = g_url;
      }
    }

    onActionFailure(args) {
      //debugger
    
      var grid = document.getElementsByClassName('e-grid')[0].ej2_instances[0] 
      
      grid.selectionModule.data.id_cosecha = g_valorpk
      grid.dataSource.dataSource.url = g_url;
      console.log('fallo');
      console.log(args);
    }

    onDataStateChange(state) {
      //debugger;
    }

    onBeforeBatchDelete(args) {
      //debugger;
    }

    onActionBegin(args) {
      var grid = document.getElementsByClassName('e-grid')[0].ej2_instances[0] 
      //grid.dataSource.dataSource.opcionRequest = args.requestType
      if (args.requestType === 'delete') {
        //debugger

        let largo = grid.dataSource.dataSource.url.length
          //grid.dataSource.dataSource.url = grid.dataSource.dataSource.url+"?$id_cosecha="+args.data[0].id_cosecha+"&$id_lote="+ args.data[0].id_lote
        grid.dataSource.dataSource.url = grid.dataSource.dataSource.url.substring(0,largo-1);
        grid.dataSource.dataSource.selectedData = JSON.stringify(grid.selectionModule.data);
        g_valorpk = args.data[0].id_cosecha;
        args.data[0].id_cosecha = "" 

          //args.data[0].id_cosecha = "?$cosecha="+args.data[0].id_cosecha+"&$lote="+ args.data[0].id_lote
            //grid.dataSource.dataSource.headers = []; 
            //this.gridObj.dataSource.dataSource.headers.push({ 'XSRF-TOKEN': $("input:hidden[name='__RequestVerificationToken']").val(), "KeywordId": args.data[0].EmployeeID, "UserId": args.data[0].Freight }); 
          //grid.dataSource.dataSource.headers.push({"Content-Type":  "application / json","api-token": `${authenticationService.currentUserValue.jwt_token}`, 
          //"id_cosecha": args.data[0].id_cosecha, "id_lote": args.data[0].id_lote }); 
        
        /* args.model.dataSource.dataSource.headers = [];
        args.model.dataSource.dataSource.headers.push({ "additional_key": args.data.document_code, "additional_key1": args.data.document_no, "additional_key2": args.data.line_no }); */
      } 
    }

    render() { 
        /* console.log(numberingSystems);
        console.log(gregorian);
        console.log(numbers);
        console.log(timeZoneNames);
        console.log(weekData); */
        debugger;

        loadCldr(numberingSystems.default, gregorian.default, numbers.default, timeZoneNames.default, weekData.default);

        return (<div className='control-pane'>
                <div className='control-section' style={{ height: "90%", width: "95%" }}>
                  <GridComponent className='e-grid' dataSource={this.data} locale='es-CO' toolbar={this.toolbarOptions} allowPaging={true} 
                        allowSorting={true} allowMultiSorting={true} 
                        editSettings={this.editSettings} query={this.query} 
                        actionFailure={this.onActionFailure} actionBegin={this.onActionBegin}
                        dataStateChange={this.onDataStateChange.bind(this)}
                        beforeBatchDelete={this.onBeforeBatchDelete.bind(this)}
                        sortingOptions = {this.sortingOptions}
                        /* toolbarClick={this.toolbarClick = this.toolbarClick.bind(this)} */
                        pageSettings={this.pageSettings} actionComplete = {this.onActionComplete = this.onActionComplete.bind(this)}
                        ref={(scope) => { this.gridObj = scope; }} onClick = {this.onClickTabla = this.onClickTabla.bind(this)}
                        height={'300px'}>
                    <ColumnsDirective>
                      {/* <ColumnDirective type='checkbox' width='50'></ColumnDirective> */}
                      <ColumnDirective field='id_cosecha' headerText='ID Cosecha' type='numeric' width='50' validationRules={this.validationNRules} isPrimaryKey={true}></ColumnDirective>
                      <ColumnDirective field='id_lote' headerText='ID Lote' type='numeric' width='50' validationRules={this.validationNRules} isPrimaryKey={true}></ColumnDirective>
                      {/* <ColumnDirective field='fecha_inicio' headerText='Fecha de Inicio' type='date' format='yyyy-MM-dd' editType='datepickeredit' edit={this.editparams} allowEditing={true} width='70' ></ColumnDirective> 
                      <ColumnDirective field='fecha_fin' headerText='Fecha de Fin' type='date' format='yyyy-MM-dd' editType='datepickeredit' edit={this.editparams} allowEditing={true} width='70' ></ColumnDirective> */}
                    </ColumnsDirective>
                    <Inject services={[Page, Toolbar, Edit, Sort]}/>
                  </GridComponent>
                </div>
              </div>);
    }
}